module.exports = __webpack_public_path__ + "static/media/zhar.3faf4e40.png";